// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"7a47a637","785":"cee0b84a"}[chunkId] + ".css";
};